/*global google*/
import React, {useEffect} from 'react'
import { MarkerClusterer } from '@react-google-maps/api'
import { ClusterOptions, ClusterStyles } from './utils'
import { RecyclingStationItem } from '../Shared/Services/RecyclingStations/interfaces'
import pinMapLg from '../images/pexmap/pin_map_large.svg'
import pinMap from '../images/pexmap/pin_map.svg'
import PexMarker from './PexMarker'
import find from 'lodash/find'
import { PexMapClustererProps } from './types'

const PexMapClusterer = (props: PexMapClustererProps) => {
    const removeClusterImages = () => {
        // Cluster images are not removed by default, so we need to remove them manually
        const interval = setInterval(() => {
            const clusterImages = document.querySelectorAll('.gm-style img'); // Google Maps cluster images
            clusterImages.forEach((img) => {
                if (img.parentElement?.className.includes('cluster')) {
                    img.remove();
                }
            });
        }, 100);

        return () => clearInterval(interval);
    };

    useEffect(() => {
        removeClusterImages();
    }, []);

    return (
        <MarkerClusterer
            averageCenter={true}
            options={ClusterOptions}
            gridSize={50}
            ignoreHidden={true}
            styles={ClusterStyles}
            calculator={props.calculator}
            onLoad={props.onLoad}
            key={`pex-map-clusterer`}
            maxZoom={16}
        >
            {clusterer => {
                return (
                    <React.Fragment>
                        {props.map &&
                            props.stations.map((station: RecyclingStationItem) => {
                                const isMarkerVisible = !!find(
                                    props.stationsFiltered,
                                    { id: station.id }
                                )
                                const isMarkerSelected = !!(
                                    props.selectedStation &&
                                    props.selectedStation.id === station.id
                                )
                                const markerIcon = isMarkerSelected
                                    ? pinMapLg
                                    : pinMap
                                return (
                                    <PexMarker
                                        key={`pex-marker-${station.id}`}
                                        visible={isMarkerVisible}
                                        icon={markerIcon}
                                        station={station}
                                        onClick={props.onMarkerClick}
                                        clusterer={clusterer}
                                    />
                                )
                            })}
                    </React.Fragment>
                )
            }}
        </MarkerClusterer>
    )
}

// Only rerender all clusters when stationsFiltered or selectedStation has changed
const MemoizedPexMapClusterer = React.memo(
    PexMapClusterer,
    (props: PexMapClustererProps, nextProps: PexMapClustererProps) => {
        if (
            props.stationsFiltered.length !== nextProps.stationsFiltered.length
        ) {
            return false
        } else if (props.selectedStation !== nextProps.selectedStation) {
            return false
        } else if (nextProps.map && props.map !== nextProps.map) {
            return false
        }
        return true
    }
)

export default MemoizedPexMapClusterer
